import SmsTemplete from './SmsTemplete';

export { SmsTemplete };



// WEBPACK FOOTER //
// src/modules/screens/settings/SmsTemplete/components/index.js